import { ClientStorageState, StorageData, StorageDetailsFetchStatus } from './schema/USQStore';
import { createStore } from 'satcheljs';
import { USQStore } from './schema/USQStore';

/** Returns initial StorageData state*/
export function getStorageDataInitialState(): StorageData {
    return {
        totalSpace: 0,
        usedSpace: 0,
        state: ClientStorageState.Normal,
        storageDetailsFetchStatus: StorageDetailsFetchStatus.NONE,
    };
}

const store = createStore<USQStore>('usqStore', {
    emailStorage: getStorageDataInitialState(),
    microsoftStorage: getStorageDataInitialState(),
    selectedItems: [],
})();

export const getUSQStore = () => store;
